module.exports = __webpack_public_path__ + "img/top_b.648e9028.png";